/* eslint-disable react-hooks/exhaustive-deps */
import { Outlet } from 'react-router-dom';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import ReactPaginate from 'react-paginate';
import Avatar from 'funifier-nice-avatar';
import { useState, useEffect, useRef } from 'react';

import { RebrandShell } from 'components/rebrand/RebrandShell';
import { IconPlus } from 'components/rebrand/icons';
import { useAuth } from 'context/AuthContext';
import { getUserByPrefixo } from 'services/dashboard.service';

import { RedeDetail } from './components/detail';
import './styles.scss';

function RedeAvatar({ item }: { item: any }) {
  if (item.avatar_type) {
    return item?.image?.medium?.url ? (
      <img src={item.image.medium.url} alt={item.nome} className="rb-galcard__img" />
    ) : (
      <span>{item.nome?.[0]}</span>
    );
  }
  return item.avatar ? <Avatar className="rb-galcard__img" {...item.avatar} /> : <span>{item.nome?.[0]}</span>;
}

export default function Rede() {
  const [list, setList] = useState<any[]>();
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [showDetail, setShowDetail] = useState('');
  const [isMounted, setIsMounted] = useState(false);
  const [loadingList, setLoadingList] = useState(true);

  const searchRef = useRef<HTMLInputElement>(null);
  const { user, userInfo } = useAuth();

  async function loadData(e?: any, itemPage?: number) {
    if (!user?._id || !userInfo) return;
    if (e) e.preventDefault();

    try {
      const rangeItem = itemPage ? itemPage * 20 : 0;
      setActivePag(itemPage || 0);
      setLoadingList(true);
      setList([]);

      const data = await getUserByPrefixo(userInfo.prefixo, searchRef.current?.value || '', rangeItem);
      setPage(data.range.pages);
      setList(data.result);
      setLoadingList(false);
    } catch (e) {
      setLoadingList(false);
    }
  }

  useEffect(() => {
    if (isMounted) {
      if (userInfo) loadData();
    } else {
      setIsMounted(true);
    }
  }, [userInfo]);

  if (showDetail) return <RedeDetail onClose={() => setShowDetail('')} id={showDetail} />;

  return (
    <RebrandShell title="Rede Reconheça BRB" subtitle="Visualize os reconhecimentos dos seus colegas em toda a rede.">
      <div className="rb-rede-banner">
        <p className="rb-rede-banner__title">Rede da Transparência Reconheça BRB</p>
        <p className="rb-rede-banner__text">Aqui você pode visualizar os reconhecimentos dos seus colegas!</p>
      </div>

      <form className="rb-rede-search" onSubmit={e => loadData(e)}>
        <input ref={searchRef} className="rb-input" placeholder="Pesquise em toda a Rede por nome ou matrícula" inputMode="search" />
        <button type="submit" className="rb-btn-primary">
          Buscar
        </button>
      </form>

      {loadingList && (
        <div className="rb-hero-grid">
          {[0, 1, 2, 3].map(i => (
            <div key={i} className="rb-skeleton" style={{ height: 280 }} />
          ))}
        </div>
      )}

      {!loadingList && list?.length === 0 && <div className="rb-empty">Nenhum resultado encontrado.</div>}

      {!loadingList && !!list?.length && (
        <div className="rb-hero-grid">
          {list.map((item: any) => (
            <div
              key={item?._id}
              className="rb-hero rb-rise"
              style={{ ['--acc' as any]: 'var(--blue-primary)', ['--acc-glow' as any]: 'rgba(26,171,227,.55)' }}
              onClick={() => setShowDetail(item.matricula)}
              role="button"
              tabIndex={0}
              aria-label={`${item.nome} - ${item.diretoria} - ${item.funcao} - ${item.matricula}`}
            >
              <div className="rb-hero__inner">
                <div className="rb-hero__avatar">
                  <div className="rb-hero__avatar-ring rb-galcard__avatar">
                    <RedeAvatar item={item} />
                  </div>
                </div>
                <div className="rb-hero__name">{item.nome}</div>
                <div className="rb-hero__role">{item.diretoria}</div>
                <div className="rb-galcard__meta">{item.funcao}</div>
                <div className="rb-galcard__meta">Matrícula {item.matricula}</div>
                <div className="rb-hero__spacer" />
                <button type="button" className="rb-vermais">
                  <IconPlus size={15} /> Ver mais
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {page > 1 && (
        <div className="rb-pagination">
          <ReactPaginate
            activeClassName={'item active '}
            breakClassName={'item break-me '}
            breakLabel={'...'}
            containerClassName={'pagination'}
            disabledClassName={'disabled-page'}
            nextClassName={'item next '}
            pageClassName={'item pagination-page '}
            previousClassName={'item previous'}
            initialPage={0}
            forcePage={activePag}
            nextLabel={<IoIosArrowForward style={{ fontSize: 18 }} />}
            onPageChange={data => loadData(null, data.selected)}
            pageRangeDisplayed={3}
            pageCount={page}
            previousLabel={<IoIosArrowBack style={{ fontSize: 18 }} />}
          />
        </div>
      )}

      <Outlet />
    </RebrandShell>
  );
}
